import React, { useEffect } from 'react';
import { message } from 'antd';
const Notification = ({ type, content, callbackResetStatus }) => {
    const [messageApi, contextHolder] = message.useMessage();
    useEffect(() => {

        const Message = (type, msg) => {
            messageApi.open({
                type,
                content: msg
            });
            const timer = setTimeout(() => {
                callbackResetStatus && callbackResetStatus();
            }, 1000);
            return () => clearTimeout(timer);
        };

        if (type === "success" && !!content) Message("success", content);
        if (type === "failed" && !!content) Message("error", content);

    }, [type])
    return (
        <React.Fragment>
            {contextHolder}
        </React.Fragment>
    );
};
export default Notification;